import { FunnelIcon } from '@heroicons/react/24/outline'

interface NoMatchesStateProps {
  onClear: () => void
}

/** Shown when the user has submissions but none match the active filters. */
export function NoMatchesState({ onClear }: NoMatchesStateProps): JSX.Element {
  return (
    <div
      className="rounded-xl border border-white/5 bg-navy-light/40 px-4 py-12 text-center"
      role="status"
      aria-live="polite"
    >
      <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-navy text-gray-500">
        <FunnelIcon className="h-6 w-6" aria-hidden="true" />
      </div>
      <p className="text-sm font-medium text-gray-300">No submissions match these filters</p>
      <p className="mx-auto mt-1 max-w-[15rem] text-xs text-gray-500">
        Try a wider time period or a different asset.
      </p>
      <button
        type="button"
        onClick={onClear}
        className="mt-4 rounded-lg bg-neon-cyan/15 px-4 py-2 text-sm font-semibold text-neon-cyan transition-colors hover:bg-neon-cyan/25 focus:outline-none focus:ring-2 focus:ring-neon-cyan"
      >
        Clear filters
      </button>
    </div>
  )
}
